// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2017 Psycle Interactive. All rights reserved.

/* globals require */

// Import third party modules
import angular from 'angular';

// Import first party modules

import './contact.scss';

const MODULE_NAME = 'contact';
angular

    .module(MODULE_NAME, [
    ])

    .directive('appContact', () => {
      return {
        restrict: 'E',
        scope: true,
        template: require('./contact.html'),
        link: ($scope, element, attrs) => {},
      };
    })

    .controller('ContactCtrl', function($http, vcRecaptchaService) {
      // ---------------------------------------------------------------------- //
      // Methods

      /**
       * onInit
       */
      function onInit() {}

      /**
       * onSubmit
       */
      function onSubmit() {
        vcRecaptchaService.execute(ctrl.widgetId);
      }

      /**
       * onSuccess
       * @param {object} token
       */
      function onSuccess(token) {
        ctrl.data['g-recaptcha-response'] = token;

        $http.post('/form-chatbots.php', ctrl.data)
            .then(function(response) {
              clearForm();
            }, function(response) {
              clearForm();
            });

        ctrl.status.sent = true;
      }

      /**
       * clearForm
       */
      function clearForm() {
        vcRecaptchaService.reload(ctrl.widgetId);
        ctrl.data = {};
      }

      /**
     * onBack
     */
      function onBack() {
        ctrl.data = {};
        ctrl.status.sent = false;
      }


      // ---------------------------------------------------------------------- //
      // Private

      // ---------------------------------------------------------------------- //
      // Public
      const ctrl = this;
      ctrl.data = {};
      ctrl.siteKey = '6LfpopUUAAAAAHA6gg-Wdhzw8DZRMkVMyB03qA3b';
      ctrl.status = {sent: false};
      ctrl.onSubmit = onSubmit;
      ctrl.onSuccess = onSuccess;
      ctrl.onBack = onBack;

      // ---------------------------------------------------------------------- //
      // Watches/events

      // ---------------------------------------------------------------------- //
      onInit();
    });

export default MODULE_NAME;
